import { IProduct, IProduction } from './../../models/commission';

export class Product implements IProduct {
  public ProductId: string;
  public ComissionId: string;
  public BankId: string;
  public CompanyId: string;
  public ProductComissionId: string = '';
  public Period: string = '';
  public CommissionType: number = 2;
  public MaxCommissionPerContract?: number;
  public Productions: IProduction[] = [
    {
      InitialProduction: 0,
      FinalProduction: 0,
      Percentage: 0,
      InvoiceValue: 0,
      TransferValue: 0,
      ProductionID: ''
    }
  ];

  constructor(
    productId: string = '',
    commissionId: string = '',
    bankId: string = '',
    companyId: string = '',
    period: string = '',
    commissionType: number = 0,
    maxCommissionPerContract?: number
  ) {
    this.ProductId = productId;
    this.ComissionId = commissionId;
    this.BankId = bankId;
    this.CompanyId = companyId;
    this.Period = period;
    this.CommissionType = commissionType;
    this.MaxCommissionPerContract = maxCommissionPerContract
  }
}
